// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__mCIIz","title":"styles_title__RxmKu","blogList":"styles_blogList__p6iPD"};